package one.healthium.domain.user.models


import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class WeightLogModel(
    val value: Float,
    val date: Instant,
)